const getHostname = (req) => {
  const serversideHost = req?.headers?.host
  if (serversideHost) {
    return serversideHost.split(':')[0]
  }
  return typeof window !== 'undefined' ? window.location.hostname : ''
}

export const siteDomain = (ctx) => {
  const req = ctx.req
  const hostname = getHostname(req)

  const full_domain = hostname && hostname.split('.')

  return full_domain[full_domain.length - 2] + '.' + full_domain[full_domain.length - 1]
}

export const siteHost = (ctx) => {
  const serversideHost = ctx?.req?.headers?.host
  if (serversideHost) {
    return serversideHost
  }
  return window.location.host
}
